export { default } from "./DimensionInfo";
